import * as Sentry from "@sentry/react";
import React from "react";
import { FlipperContext } from "../../../shared/lib/FlipperContext";
import "../../../shared/lib/sentry";
import renderWithLayout from "./renderWithLayout";
import Fallback from "../../../shared/components/Fallback";

export default function renderForRoR<T>(Component: React.ComponentType<T>) {
  return function InnerComponent(
    props: T & React.JSX.IntrinsicAttributes,
    railsContext: {
      current_user_code: unknown;
      request_id: unknown;
      flipper: Record<string, boolean>;
    },
  ) {
    Sentry.setContext("Additional", {
      current_user_code: railsContext.current_user_code,
      request_id: railsContext.request_id,
    });
    const result = renderWithLayout(() => (
      <Sentry.ErrorBoundary fallback={<Fallback />}>
        <FlipperContext.Provider value={railsContext.flipper}>
          <Component {...props} />
        </FlipperContext.Provider>
      </Sentry.ErrorBoundary>
    ));
    return result;
  };
}
